module.exports = __webpack_public_path__ + "92e2c3306964903e837b89cd5aba6477.svg";